import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { InvoicesService } from '../../../services/invoices.service';
import { environment } from '../../../../environments/environment';
import { paymentProcessService } from '../../../services/payment-process.service';
import { BansStorageService } from '../../../services/bans-storage.service';

interface IPaymentDetails {
  amount: number;
  currency: string;
  description: string;
  payment_method: string;
  customer: string;
}

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit {
  disabled = false;
  saveCard = false;
  selectedSavedCard: string = "";
  selectedSavedCardCVC?: number;
  invoiceList: Array<any> = new Array();
  historicalInvoicePymtIndicator: boolean;
  amount: any = 0;
  ban!: string;
  tabLoadTimes: Date[] = [];
  paymentMethods: any = [];
  serviceFee: string = "0.00";
  selectedPaymentMethod: any;
  isNewPaymentExperienceEnable: boolean = environment.newPaymentExperienceEnableFlag;

  constructor(private http: HttpClient, private router: Router, private invoicesService: InvoicesService, private bansService: BansStorageService, private paymentProcessService: paymentProcessService) {
    let historicalInvoicePymtIndicator = this.router.url.includes("/historical-data")
    this.historicalInvoicePymtIndicator = historicalInvoicePymtIndicator
    if (this.historicalInvoicePymtIndicator) {
      let ban = localStorage.getItem("ban")
      if (!ban) this.router.navigate(["invoices/historical-data"])
      else this.ban = ban
      let amountToPay = localStorage.getItem("totalAmountToPay") || "0"
      this.amount = parseFloat(parseFloat(amountToPay).toFixed(2))
      if (this.amount == 0) this.router.navigate(["invoices/historical-data"])
      return;
    }
    let invoiceToCheckoutInStorage = JSON.parse(localStorage.getItem("InvoiceList") || "[]");
    console.log("Storage checkout invoices", invoiceToCheckoutInStorage)
    let checkoutInvoices = Array.isArray(invoiceToCheckoutInStorage) ? invoiceToCheckoutInStorage : invoiceToCheckoutInStorage?.invoices;
    console.log("List", checkoutInvoices)
    if(checkoutInvoices.length == 0) this.router.navigate(["invoices"])
    this.ban = checkoutInvoices[0].bpNo;
    checkoutInvoices.forEach((element: any) => {
      this.invoiceList.push(element);
      this.amount = this.amount + parseFloat(parseFloat(element.editedAmountToPay).toFixed(2));
    });
    console.log(this.ban)
    if (!this.historicalInvoicePymtIndicator) localStorage.setItem("totalAmountToPay", this.amount);
    console.log(this.invoiceList.length)
  }

  ngOnInit() {
    // this.getListOfPayments()
    let isSledCustomer : boolean = false;
    this.bansService.bansApiResponse.subscribe((bansResponse: any) => {
      if (bansResponse) {
        let sledBan = bansResponse.find((x: { bancust: string; }) => x.bancust == this.ban) || { zzachclass_bus: "", contractacc: "" };
        isSledCustomer = sledBan.zzachclass_bus == 'SLED';
      }
    })
    this.paymentProcessService.paymentMethod.subscribe((paymentMethod: any) => {
        if(paymentMethod){
          this.selectedPaymentMethod = paymentMethod;
          if(paymentMethod.paymentType.toLowerCase() == "card" && !isSledCustomer){
            this.serviceFee = "8.95";
          }
          else{
            this.serviceFee = "0.00";
          }
        }
        
    })
  }

  async getListOfPayments() {
    await this.invoicesService.getPaymentMethods(this.ban).subscribe((res: any) => {
      this.paymentMethods = res;
      res.paymentMethods.forEach((element: any) => {
        //   if ((element.truncatedDda && element.truncatedDda.includes(this.lastDigit)) || (element.cardNumber && element.cardNumber.includes(this.lastDigit))) {
        //     // this.defaultPaymentMethodId = this.paymentMethod + "-" + (this.paymentMethod == 'ACH' ? element.truncatedDda : element.cardNumber);
        // }
      });
    });
  }

  getTimeLoaded(index: number) {
    if (!this.tabLoadTimes[index]) {
      this.tabLoadTimes[index] = new Date();
    }

    return this.tabLoadTimes[index];
  }

}
